import { FC, useEffect, useState } from "react";
import "./BackToTop.css";

export const BackToTop: FC = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 350) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <nav
      className={`back-to-top ${showButton ? "active" : ""}`}
      aria-label="Voltar ao topo da página"
    >
      <a
        href="#wrapper"
        onClick={(e) => {
          e.preventDefault();
          scrollToTop();
        }}
      >
        <span className="fa fa-chevron-up"></span>
        <span className="sr-only">Voltar ao topo da página</span>
      </a>
    </nav>
  );
};
